import {
  faCalendarDays,
  faMoneyBill,
  faMoneyBill1Wave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTheme } from "@material-ui/styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Menu,
  MenuItem,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import React from "react";
import MyAvatar from "src/components/MyAvatar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Delete } from "@material-ui/icons";
import useCustomConfirmSnackBar from "src/components/CustomComponents/useCustomConfirmSnackBar";
import {
  deleteb2bAgnetApi,
  deleteSupplierApi,
} from "src/Api/Services/AgentFareRule";
import { useSnackbar } from "notistack5";
import ReplicaSupplierComp from "./ReplicaSupplierComp";
import InfoOutlineIcon from "@mui/icons-material/Info";
const SupplierHeadComp = ({
  provd,
  isOpen,
  toggleOpen,
  row,
  fetchData,
  agentData,
  userRole,
  loadPre,
}) => {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const showConfirmAlert = useCustomConfirmSnackBar();
  const handleDelete = async (userId, gdsId) => {
    try {
      const { data } = await deleteSupplierApi(userId, gdsId);
      if (data.statusCode === 200) {
        fetchData();
      }
      enqueueSnackbar(data.message, {
        variant: data.statusCode === 200 ? "success" : "error",
      });
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };

  return (
    <>
      <Accordion className="newAccord">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className="accordIcon" />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div
            className="d-flex align-items-center w-full"
            style={{
              borderBottom: "1px solid rgb(241 241 241)",
              borderColor: theme.palette.primary.light,
              paddingBottom: "14px",
            }}
          >
            <div className="mr-3 d-flex align-items-center">
              <MyAvatar />
            </div>
            <div className="d-flex align-items-center justify-content-between w-full">
              <div
                className="d-flex align-items-center gap-12"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="d-flex  justify-content-center flex-column mx-1">
                  <Typography
                    sx={{
                      color: "primary.main",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                    }}
                    className=" font-bolder"
                    variant="h6"
                  >
                    {provd.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    className="text-gray-700 font-bold mb-1"
                  >
                    Provider
                  </Typography>
                </div>
                {["admin", "superAdmin"].includes(userRole) && !provd?.isLcc && (
                  <FormControlLabel
                    control={
                      <Switch
                        defaultChecked={provd.isHoldActive ? true : false}
                        checked={isOpen[provd.name]}
                        name={provd.name + "isHoldActive"}
                        onChange={(e) => {
                          toggleOpen(e.target, row, provd, "isHoldActive");
                        }}
                        inputProps={{
                          "aria-label": "controlled",
                        }}
                        className="mySwitch"
                      />
                    }
                    label={
                      <div>
                        Pre Hold Status
                        <Tooltip
                          color="error"
                          title="If pre-hold is active, the ticket will be HOLD before payment. Please enable this option carefully."
                        >
                          <InfoOutlineIcon fontSize="small" className="mx-1" />
                        </Tooltip>
                      </div>
                    }
                  />
                )}
              </div>
              {["admin", "superAdmin", "user", "readuser"].includes(
                userRole,
              ) && (
                <div
                  className="d-flex align-items-center gap-8"
                  style={{ marginRight: "60px" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {userRole !== "user" && userRole !== "readuser" && (
                    <div>
                      <IconButton
                        color="error"
                        onClick={() =>
                          showConfirmAlert("Are you sure?", "warning", () =>
                            handleDelete(row.userid, provd.gdsType),
                          )
                        }
                      >
                        <Delete />
                      </IconButton>
                      <span>Delete</span>
                    </div>
                  )}
                  <FormControlLabel
                    control={
                      <Switch
                        defaultChecked={provd.supStatus === "Y" ? true : false}
                        checked={isOpen[provd.name]}
                        name={provd.name + "supStatus"}
                        disabled={loadPre}
                        onClick={(e) => {
                          if (
                            userRole === "user" ||
                            userRole === "readuser" ||
                            loadPre
                          ) {
                            e.preventDefault();
                            e.stopPropagation();
                          }
                        }}
                        onChange={(e) => {
                          if (
                            userRole === "user" ||
                            userRole === "readuser" ||
                            loadPre
                          ) {
                            return;
                          }
                          toggleOpen(e.target, row, provd, "supStatus");
                        }}
                        className="mySwitch"
                      />
                    }
                    label="Supplier Status"
                  />
                  {["admin", "superAdmin"].includes(userRole) && (
                    <ReplicaSupplierComp
                      agentData={agentData}
                      provd={provd}
                      metaList={row.apiprovider}
                      fetchData={fetchData}
                      metaId={row?.userid}
                      userRole={userRole}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </AccordionSummary>

        <AccordionDetails>
          <div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <FontAwesomeIcon
                icon={faMoneyBill}
                className="text-gray-400 pe-2 fa-sm"
              />
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                Amount
              </Typography>
              <Typography
                style={{ fontSize: "17px" }}
                className="text-gray-700 font-bold"
              >
                {row.amount} {row.rule}
              </Typography>
            </div>

            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <FontAwesomeIcon
                icon={faCalendarDays}
                className="text-gray-400 pe-2"
              />
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                Valid From
              </Typography>
              <Typography
                style={{ fontSize: "17px" }}
                className="text-gray-700 font-bold"
              >
                {moment(row.fromDate).format("MMM DD, YYYY")}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <FontAwesomeIcon
                icon={faCalendarDays}
                className="text-gray-400 pe-2"
              />
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                Valid To
              </Typography>
              <Typography
                style={{ fontSize: "17px" }}
                className="text-gray-700 font-bold"
              >
                {moment(row.toDate, "DD/MM/YYYY").format("MMM DD, YYYY")}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <i class="fas fa-plane-departure fa-xs text-gray-400 pe-2"></i>
              <Typography
                className="text-gray-700 font-bold"
                style={{
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                  minWidth: "220px",
                }}
              >
                Allowed Airlines{" "}
              </Typography>
              <Typography
                style={{ fontSize: "17px" }}
                className="text-gray-700 font-bold"
              >
                {provd.code === "" ? "N/A" : <>{provd.code}</>}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <FontAwesomeIcon
                icon={faMoneyBill1Wave}
                className="text-gray-400 pe-2 fa-sm"
              />
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                Fare type
              </Typography>

              <Typography style={{ wordBreak: "break-all" }}>
                {provd.fareType}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <i class="fas fa-plane-departure fa-xs text-gray-400 pe-2"></i>
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                Airline Markup
              </Typography>

              <Typography style={{ wordBreak: "break-all" }}>
                {provd.airlineMarkup === "" ? (
                  "N/A"
                ) : (
                  <>{provd.airlineMarkup}</>
                )}
              </Typography>
            </div>

            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <FontAwesomeIcon
                icon={faMoneyBill1Wave}
                className="text-gray-400 pe-2  fa-sm"
              />
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                Fare Markup
              </Typography>
              <Typography style={{ wordBreak: "break-all" }}>
                {provd.fareTypeMarkup == "" ? (
                  "N/A"
                ) : (
                  <>{provd.fareTypeMarkup}</>
                )}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <i class="fas fa-plane-departure fa-xs text-gray-400 pe-2"></i>
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                TripType Source
              </Typography>

              <Typography>
                {row.tripTypeSource == "" ? "N/A" : <>{row.tripTypeSource}</>}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <i class="fas fa-plane-departure fa-xs text-gray-400 pe-2"></i>
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                PAX Source
              </Typography>

              <Typography>
                {row.noOfPAXSource === 0 ? "Any" : <>{row.noOfPAXSource}</>}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <i class="fas fa-plane-departure fa-xs text-gray-400 pe-2"></i>
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                BlockCountrySource
              </Typography>

              <Typography style={{ wordBreak: "break-all" }}>
                {row.blockedCountrySource == "" ? (
                  "N/A"
                ) : (
                  <>{row.blockedCountrySource}</>
                )}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <i class="fas fa-plane-departure fa-xs text-gray-400 pe-2"></i>
              <Typography
                className="text-gray-700 font-bold"
                style={{
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                  minWidth: "220px",
                }}
              >
                BlockAirportSource{" "}
              </Typography>
              <Typography style={{ wordBreak: "break-all" }}>
                {row.blockedAirportSource === "" ? (
                  "N/A"
                ) : (
                  <>{row.blockedAirportSource}</>
                )}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <i class="fas fa-plane-departure fa-xs text-gray-400 pe-2"></i>
              <Typography
                className="text-gray-700 font-bold"
                style={{
                  fontSize: "17px",
                  letterSpacing: "0.6px",
                  minWidth: "220px",
                }}
              >
                Allowed Airport
              </Typography>
              <Typography style={{ wordBreak: "break-all" }}>
                {provd.blockedAirport}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <FontAwesomeIcon
                icon={faMoneyBill}
                className="text-gray-400 pe-2 fa-sm"
              />
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                extraMarkupAmount
              </Typography>
              <Typography
                style={{ fontSize: "17px" }}
                className="text-gray-700 font-bold"
              >
                {provd.extraMarkup}
              </Typography>
            </div>
            <div className="d-flex align-items-center mb-3 pb-3 border-bottom emptycell-none">
              <FontAwesomeIcon
                icon={faMoneyBill}
                className="text-gray-400 pe-2 fa-sm"
              />
              <Typography
                className="  text-gray-700 font-bold"
                style={{
                  minWidth: "220px",
                  fontSize: "17px",
                  letterSpacing: "0.5px",
                }}
              >
                Convenience fee
              </Typography>
              <Typography
                style={{ fontSize: "17px" }}
                className="text-gray-700 font-bold"
              >
                {row.convFee}
              </Typography>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default SupplierHeadComp;
